import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

export default function SaasCTA({ onBookDemo, onStartTrial }) {
  return (
    <section className="py-28 bg-slate-950 text-white relative overflow-hidden text-center px-4">
      {/* Background gradients glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-gradient-to-tr from-violet-600/20 via-blue-500/10 to-transparent blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(rgba(255,255,255,0.015)_1px,transparent_1px)] [background-size:20px_20px]" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10 space-y-8">
        
        {/* Sparkle Tag */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full text-violet-300 text-xs font-black shadow-inner">
          <Sparkles size={12} className="text-violet-400" />
          <span>Launch Today</span>
        </div>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.1]">
          Ready to Transform <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 via-blue-400 to-cyan-400">
            Your Institute's Campus?
          </span>
        </h2>

        {/* Subtitle */}
        <p className="text-slate-400 text-base sm:text-lg max-w-xl mx-auto font-medium leading-relaxed">
          Join hundreds of institutions worldwide using our modern LMS to conduct secure online exams, leverage AI tutors, and automate school operations.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 pt-6">
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={onBookDemo}
            className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-violet-600 to-blue-650 text-white font-black rounded-2xl shadow-xl shadow-blue-500/20 text-base"
          >
            Book Free Demo
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={onStartTrial}
            className="w-full sm:w-auto px-8 py-4 bg-white/5 hover:bg-white/10 text-white border border-white/10 rounded-2xl text-base font-black flex items-center justify-center gap-2 transition-all"
          >
            Start Free Trial <ArrowRight size={18} />
          </motion.button>
        </div>

      </div>
    </section>
  );
}
